import Dashboard from "./components/Dashboard";
import CryptoPromo from "./components/CryptoPromo";

function App() {
  return (
    <div className="App">
      <Dashboard />
      <CryptoPromo /> {/* 👈 Always visible everywhere */}
    </div>
  );
}

export default App;
